import React, { lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import "./Magic.css";

export default function Registration({ links, sunwestLink, angelAiLink}) {
  const imgCDNURL = process.env.REACT_APP_APSECOND;
  return (
    <>
      <div className="registartionsect">
        <Container>
          <Row>
            <Col sm={12} md={12} xl={5} lg={5}>
              <img
                src={imgCDNURL + "magiximage.png"}
                className="magixhat"
                loading="lazy"
              />
            </Col>
            <Col sm={12} md={12} xl={7} lg={7}>
              <p className="magicmorgan">
                <span className="Morganneed">{htmlParser(angelAiLink)}:</span> The Magic Wand for
                Your Mortgage Needs
              </p>
              <p className="neverending">
                Are you tired of waiting on hold for hours or being stuck in a
                never-ending email thread when trying to get answers to your
                loan questions?
              </p>
              <p className="hellomorganlisy">
                <span className="hellomorgan">
                  Say hello to {htmlParser(angelAiLink)}, the ultimate loan companion who is
                  available 24/7 to grant your loan wishes.
                </span>
                <ul>
                  <li>
                    Free lead nurturing: Helps you to generate leads and nurture
                    them until they are ready to buy
                  </li>
                  <li>
                  {htmlParser(angelAiLink)} generator listing website: Helps you attract more
                    potential buyers
                  </li>
                  <li>
                    24/7 support: Get immediate answers to your buyers'
                    financing questions and stay ahead of the competition
                  </li>
                </ul>
              </p>
              <p className="busysingnal">
                <span className="delayedtext">
                  {" "}
                  Never a Busy Signal, Never a Delayed Email
                </span>
                <ul>
                  <li>
                    TRU Approvals and a no loan contingency offer that is
                    equivalent in strength to a cash offer
                  </li>
                  <li>
                    Backed 100% by {htmlParser(sunwestLink)} for complete confidence in your
                    financing
                  </li>
                </ul>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
